
import * as handlebars_family from "./handlebars_family.js";
import "./layout/layout_global.mustache";
import "./widget/ads-adder.js";
const TPL = handlebars_family.addTemplate("page_contacts",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcol class=\"pane-left\" style=\"max-width:400px\"></flexcol><flexauto class=\"pane-main\" style=\"border-left:var(--border);\"></flexauto> "
    + ((stack1 = lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),"displayAds",{"name":"premiumPermission","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":233},"end":{"line":1,"column":583}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    return " <div class=\"pane-right open\" style=\"--opened-width:300px;width:332px;padding:16px;\"><section data-widget=\"widget/ads-adder\" slot-type=\"othersections_portait\"></section><section style=\"margin-top:24px;\" data-widget=\"widget/ads-adder\" slot-type=\"othersections_mediumrectangle\"></section></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_global"),depth0,{"name":"layout/layout_global","hash":{"addButton":"contactnew","pageKey":"mainMenu.contacts","isPageContact":true},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;